var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pt-6 pb-6",staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"text-h3"},[_vm._v(_vm._s(_vm.actualNumber))]),_c('br'),_c('span',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }